import { AbstractControl, FormControl, FormGroup, ValidationErrors } from '@angular/forms';

export function coliValidator(control: AbstractControl): ValidationErrors | null {
  const val = control.value;
  if (val === null || val === undefined || val === '') {
    return null;
  }
  const num = Number(val);
  if (!Number.isInteger(num) || num < 1) {
    return { integerMin: { message: 'Must be a whole number of 1 or more' } };
  }
  return null;
}

export function shelfLifeDaysValidator(control: AbstractControl): ValidationErrors | null {
  const val = control.value;
  if (val === null || val === undefined || val === '') {
    return null;
  }
  const num = Number(val);
  if (!Number.isInteger(num) || num < 0) {
    return { integerMin: { message: 'Must be a whole number of 0 or more' } };
  }
  return null;
}

export function createVendorOrderFormControls(): Record<string, FormControl> {
  return {
    vendorID: new FormControl(''),
    vendorName: new FormControl(''),
    orderNumber: new FormControl(''),
    producer: new FormControl(''),
    country: new FormControl(''),
    coli: new FormControl(null, [coliValidator]),
    shelfLifeDays: new FormControl(null, [shelfLifeDaysValidator])
  };
}

export function appendVendorOrderFormData(fd: FormData, formValue: any): void {
  fd.append('vendorID', formValue.vendorID || '');
  fd.append('vendorName', formValue.vendorName || '');
  fd.append('orderNumber', formValue.orderNumber || '');
  fd.append('producer', formValue.producer || '');
  fd.append('country', formValue.country || '');
  if (formValue.coli !== null && formValue.coli !== undefined && formValue.coli !== '') {
    fd.append('coli', String(formValue.coli));
  }
  if (formValue.shelfLifeDays !== null && formValue.shelfLifeDays !== undefined && formValue.shelfLifeDays !== '') {
    fd.append('shelfLifeDays', String(formValue.shelfLifeDays));
  }
}

export function patchVendorOrder(form: FormGroup, product: any): void {
  form.patchValue({
    vendorID: product?.vendorID || '',
    vendorName: product?.vendorName || '',
    orderNumber: product?.orderNumber || '',
    producer: product?.producer || '',
    country: product?.country || '',
    coli: product?.coli ?? null,
    shelfLifeDays: product?.shelfLifeDays ?? null
  });
}
